import siteConfig from "@iso/config/site.config";
import {
  getGetRequestInfo,
  getDeleteRequestInfo,
  getPutRequestInfo,
  getPostRequestInfo,
  getRequestGeneratorFunction
} from "@iso/utils/connectUtils";
import { put } from "redux-saga/effects";
import siteUrls from "src/infinode/constants/urls/siteUrls";
import actions from "./actions";
import { upperFirst } from "lodash";

const { getSiteList, siteRootUrl, getAddSiteDateSourceUrl, getRemoveSiteDateSourceUrl, getSiteDemandUrl } = siteUrls;

const onGetSiteListRequest = ({ token }) =>
  fetch(`${siteConfig.apiUrl}${getSiteList}`, getGetRequestInfo(token)).then(response => response);

const onGetSiteListSuccess = function* (resultBody) {
  if (resultBody.sites !== undefined) {
    yield put({
      type: actions.GET_SITES_SUCCESS,
      sites: resultBody.sites
    });
    return true;
  }
  return false;
};

const getSiteListRequest = getRequestGeneratorFunction(
  actions.GET_SITES_REQUEST,
  actions.SITES_ERROR,
  onGetSiteListRequest,
  onGetSiteListSuccess
);

const onGetSiteRequest = ({ token, id }) =>
  fetch(`${siteConfig.apiUrl}${siteRootUrl}/${id}`, getGetRequestInfo(token)).then(response => response);

const onGetSiteSuccess = function* (resultBody) {
  if (resultBody.site) {
    yield put({
      type: actions.GET_SITE_SUCCESS,
      site: resultBody.site
    });
    return true;
  }
  return false;
};

const getSiteRequest = getRequestGeneratorFunction(
  actions.GET_SITE_REQUEST,
  actions.SITES_ERROR,
  onGetSiteRequest,
  onGetSiteSuccess
);

const onDeleteSiteRequest = ({ token, id }) =>
  fetch(`${siteConfig.apiUrl}${siteRootUrl}/${id}`, getDeleteRequestInfo(token)).then(response => response);

const onDeleteSiteSuccess = function* (resultBody, params) {
  if (resultBody === true) {
    yield put({
      type: actions.DELETE_SITE_SUCCESS,
      id: params.id
    });
    return true;
  }
  return false;
};

const deleteSiteRequest = getRequestGeneratorFunction(
  actions.DELETE_SITE_REQUEST,
  actions.SITES_ERROR,
  onDeleteSiteRequest,
  onDeleteSiteSuccess
);

const onUpdateSiteRequest = ({ token, site }) =>
  fetch(`${siteConfig.apiUrl}${siteRootUrl}/${site.id}`, getPutRequestInfo(site, token)).then(response => response);

const onUpdateSiteSuccess = function* (resultBody) {
  if (resultBody.site) {
    yield put({
      type: actions.UPDATE_SITE_SUCCESS,
      site: resultBody.site
    });
    return true;
  }
  return false;
};

const updateSiteRequest = getRequestGeneratorFunction(
  actions.UPDATE_SITE_REQUEST,
  actions.SITES_ERROR,
  onUpdateSiteRequest,
  onUpdateSiteSuccess
);

const onCreateSiteRequest = ({ token, site }) =>
  fetch(`${siteConfig.apiUrl}${siteRootUrl}`, getPostRequestInfo(site, token)).then(response => response);

const onCreateSiteSuccess = function* (resultBody) {
  if (resultBody.site) {
    yield put({
      type: actions.CREATE_SITE_SUCCESS,
      site: resultBody.site
    });
    return true;
  }
  return false;
};

const createSiteRequest = getRequestGeneratorFunction(
  actions.CREATE_SITE_REQUEST,
  actions.SITES_ERROR,
  onCreateSiteRequest,
  onCreateSiteSuccess
);

const onAddSiteDataSourceRequest = ({ token, siteId, zoneId, circuitId, dataSourceType, positive }) =>
  fetch(
    `${siteConfig.apiUrl}${getAddSiteDateSourceUrl(siteId)}`,
    getPutRequestInfo({ zoneId, circuitId, dataSourceType: upperFirst(dataSourceType), positive }, token)
  ).then(response => response);

const onAddSiteDataSourceSuccess = function* (resultBody, { siteId, zoneId, circuitId, dataSourceType, positive }) {
  if (resultBody) {
    yield put({
      type: actions.ADD_SITE_DATA_SOURCE_SUCCESS,
      siteId,
      zoneId,
      circuitId,
      dataSourceType,
      positive
    });
    return true;
  }
  return false;
};

const addSiteDataSourceRequest = getRequestGeneratorFunction(
  actions.ADD_SITE_DATA_SOURCE_REQUEST,
  actions.SITES_ERROR,
  onAddSiteDataSourceRequest,
  onAddSiteDataSourceSuccess
);

const onRemoveSiteDataSourceRequest = ({ token, siteId, zoneId, circuitId, dataSourceType }) =>
  fetch(
    `${siteConfig.apiUrl}${getRemoveSiteDateSourceUrl(siteId)}`,
    getPutRequestInfo({ zoneId, circuitId, dataSourceType: upperFirst(dataSourceType) }, token)
  ).then(response => response);

const onRemoveSiteDataSourceSuccess = function* (resultBody, { siteId, zoneId, circuitId, dataSourceType }) {
  if (resultBody) {
    yield put({
      type: actions.REMOVE_SITE_DATA_SOURCE_SUCCESS,
      siteId,
      zoneId,
      circuitId,
      dataSourceType
    });
    return true;
  }
  return false;
};

const removeSiteDataSourceRequest = getRequestGeneratorFunction(
  actions.REMOVE_SITE_DATA_SOURCE_REQUEST,
  actions.SITES_ERROR,
  onRemoveSiteDataSourceRequest,
  onRemoveSiteDataSourceSuccess
);

const onUpdateSiteDemandConfigRequest = ({ token, siteId, demandSwitch, demandThreshold }) =>
  fetch(
    `${siteConfig.apiUrl}${getSiteDemandUrl(siteId)}`,
    getPutRequestInfo({ siteId, demandSwitch, threshold: demandThreshold }, token)
  ).then(response => response);

const onUpdateSiteDemandConfigSuccess = function* (resultBody, { siteId, demandSwitch, demandThreshold }) {
  if (resultBody) {
    yield put({
      type: actions.UPDATE_SITE_DEMAND_CONFIG_SUCCESS,
      siteId,
      demandSwitch,
      demandThreshold
    });
    return true;
  }
  return false;
};

const updateSiteDemandConfigRequest = getRequestGeneratorFunction(
  actions.UPDATE_SITE_DEMAND_CONFIG_REQUEST,
  actions.SITES_ERROR,
  onUpdateSiteDemandConfigRequest,
  onUpdateSiteDemandConfigSuccess
);

export default {
  getSiteListRequest,
  getSiteRequest,
  deleteSiteRequest,
  updateSiteRequest,
  createSiteRequest,
  addSiteDataSourceRequest,
  removeSiteDataSourceRequest,
  updateSiteDemandConfigRequest
};
